import Vue from 'vue'
import Router from 'vue-router'
//import Store from './vuex/store.js'
//import Utilities from './utilities'

Vue.use(Router)

let router = new Router({
    mode: process.env.VUE_APP_ROUTER_MODE,
    routes:
    [
        {
            path: '/',
            name: 'homepage',
            //is_private: false, //custom attribute
            component: () => import('./components/views/homepage').then(function(Homepage) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Homepage View loaded')
                return Homepage
            }),
        },
        {
            path: '/request',
            name: 'request',
            //is_private: false, //custom attribute
            component: () => import('./components/views/request').then(function(Request) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Request View loaded')
                return Request
            }),
        },
        {
            path: '/review/:travel_review_id/:secret/:noTrack?',
            name: 'review',
            props: route => ({
              travel_review_id: route.params.travel_review_id,
              secret: route.params.secret,
              noTrack: (route.params.noTrack)? true : false
            }),
            //is_private: false, //custom attribute
            component: () => import('./components/views/review-redirect').then(function(ReviewRedirect) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: ReviewRedirect View loaded')
                return ReviewRedirect
            }),
        },
        {
          path: '/proposta/:request_id/:secret/:noTrack?',
          name: 'proposta',
          props: route => ({
            request_id: route.params.request_id,
            secret: route.params.secret,
            noTrack: (route.params.noTrack)? true : false
          }),
          //is_private: false, //custom attribute
          component: () => import('./components/views/review').then(function(Review) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Review View loaded')
            return Review
          }),
        },
        {
            path: '/detail/:travel_id',
            name: 'detail',
            //is_private: false, //custom attribute
            props: true,
            component: () => import('./components/views/detail').then(function(Detail) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Detail View loaded')
                return Detail
            }),
        },
        {
            path: '/category/:category_code',
            name: 'category',
            //is_private: false, //custom attribute
            props: true,
            component: () => import('./components/views/category').then(function(Category) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Category View loaded')
                return Category
            }),
        },
        {
            path: '/post/:post_id/:title?',
            name: 'post',
            //is_private: false, //custom attribute
            props: true,
            component: () => import('./components/views/post').then(function(Post) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Post View loaded')
                return Post
            }),
        },
        {
            path: '/checkout',
            name: 'checkout',
            //is_private: false, //custom attribute
            props: true,
            component: () => import('./components/views/checkout').then(function(Checkout) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Checkout View loaded')
                return Checkout
            }),
        },
        {
            path: '/confirm/:travel_voucher_id/:confirm_code',
            name: 'confirm',
            //is_private: false, //custom attribute
            props: true,
            component: () => import('./components/views/confirm').then(function(Confirm) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Confirm View loaded')
                return Confirm
            }),
        },
        {
            path: '/notifications',
            name: 'notifications',
            //publicRoute: false, //custom attribute
            component: () => import('./components/views/notifications').then(function(Notifications) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Notifications View loaded')
                return Notifications
            }),
        },
        {
          path: '/faq',
          name: 'faq',
          //publicRoute: false, //custom attribute
          component: () => import('./components/views/faq').then(function(Faq) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Faq View loaded')
            return Faq
          }),
        },
        {
          path: '/termini-e-condizioni',
          name: 'terms',
          //publicRoute: false, //custom attribute
          component: () => import('./components/views/terms').then(function(Terms) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Terms View loaded')
            return Terms
          }),
        },
        {
          path: '/informazioni',
          name: 'informazioni',
          //publicRoute: false, //custom attribute
          component: () => import('./components/views/informazioni').then(function(Informazioni) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Informazioni View loaded')
            return Informazioni
          }),
        },
        {
          path: '/informazioni#about',
          name: 'about',
          //publicRoute: false, //custom attribute
          component: () => import('./components/views/informazioni').then(function(Informazioni) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Informazioni View loaded')
            return Informazioni
          }),
        },
        {
          path: '/informazioni#assistenza',
          name: 'contacts',
          //publicRoute: false, //custom attribute
          component: () => import('./components/views/informazioni').then(function(Informazioni) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Informazioni View loaded')
            return Informazioni
          }),
        },
        {
          path: '/paga/:pay_code/:payment_link_id',
          name: 'payments-link',
          //publicRoute: false, //custom attribute
          component: () => import('./components/views/payments-link').then(function(PaymentsLink) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: PaymentsLink View loaded')
            return PaymentsLink
          }),
        },
        {
          path: '/messages/:request_id/:secret/:noTrack?',
          name: 'messages',
          props: route => ({
            request_id: route.params.request_id,
            secret: route.params.secret,
            noTrack: (route.params.noTrack)? true : false
          }),
          //publicRoute: false, //custom attribute
          component: () => import('./components/views/messages').then(function(Messages) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Messages View loaded')
            return Messages
          }),
        },

    ]
})

router.beforeEach((to, from, next) => {
    (to, from, next)
    
    /*
    let route = router.options.routes.filter(function(route){ return route.name == to.name })[0],
        is_private = route.is_private
    
    if(is_private)
    {
        if(!Store.state.token)
        {
            router.push('/homepage')
            return
        }
    }
    */

    window.scrollTo(0,0)

    next()
    return
})

router.afterEach((to) => {

  // quando torno indietro con history back, nella home ci sono molti componenti caricati in modo asincrono: il browser "ricorda" che deve tornare indietro a (esempio) 1500px di scroll verticale, e lo fa

  if(to.name == "homepage")
  {
    setTimeout(function(){
      window.scrollTo(0,0)
    },100)
  }

  if(to.name == "contacts")
  {
    setTimeout(function(){

      if(process.env.VUE_APP_MODE != 'production') window.console.log('scrolling to ' + to.hash)
      document.getElementById('assistenza').scrollIntoView();

    }, 500);
  }

  // per scrollare alle sezioni di id #id
  // bisogna gestirlo in parte manualmente
  // se hai già il sito caricato, i fragment funzionano
  // ma se arrivi da fuori con link con fragment, va gestito così
  if(to.hash && to.hash != ''){

    if(process.env.VUE_APP_MODE != 'production') window.console.log('fragment found')

    setTimeout(function(){

      if(process.env.VUE_APP_MODE != 'production') window.console.log('scrolling to ' + to.hash)
      document.getElementById(to.hash.substr(1)).scrollIntoView();

    }, 1000);

  }

})


export default router